import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { ManagementsService } from '../../services/managements-service';
import { ManagementInfo } from '../../models/management-info';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-get-management-details',
  templateUrl: './get-management-details.component.html',
  styleUrls: ['./get-management-details.component.scss'],
})
export class GetManagementDetailsComponent extends BaseComponent implements OnInit {
  model = {} as ManagementInfo;
  constructor(
    public service: ManagementsService,
    route: Router,
    private diag: NbDialogRef<GetManagementDetailsComponent>,
    private toast: NbToastrService,
    public sanitizer: DomSanitizer
  ) {
    super(route, service, null);
  }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  close(){
    this.diag.close();
  }
}
